__turbopack_context__.v({
  "productImage": "qzyllq_productImage",
  "sectionTitle": "qzyllq_sectionTitle",
  "specLabel": "qzyllq_specLabel",
  "specRow": "qzyllq_specRow",
  "specTable": "qzyllq_specTable",
  "specValue": "qzyllq_specValue",
  "specificationSection": "qzyllq_specificationSection",
  "techContainer": "qzyllq_techContainer",
  "title": "qzyllq_title",
});
